import React, { useEffect, useState } from "react";
import { getCommonConfig, updateCommonConfig } from "@/services/commonconfig";

const Toggle = ({
  enabled,
  onToggle,
}: {
  enabled: boolean;
  onToggle: (value: boolean) => void;
}) => (
  <div className="flex border border-gray-300 rounded overflow-hidden">
    <button
      type="button"
      className={`px-3 py-1 text-xs ${
        enabled
          ? "bg-[var(--color-brand)] text-white"
          : "bg-gray-100 text-gray-600"
      }`}
      onClick={() => onToggle(true)}
    >
      Enable
    </button>

    <button
      type="button"
      className={`px-3 py-1 text-xs ${
        !enabled
          ? "bg-[var(--color-brand)] text-white"
          : "bg-gray-100 text-gray-600"
      }`}
      onClick={() => onToggle(false)}
    >
      Disable
    </button>
  </div>
);

const NotificationWidgetConfig: React.FC = () => {
  const [configData, setConfigData] = useState<any>({});
  const [savedConfig, setSavedConfig] = useState<any>(null);
  const [saving, setSaving] = useState(false);

  const [notificationUrl1, setNotificationUrl1] = useState("");
  const [notificationUrl2, setNotificationUrl2] = useState("");
  const [notificationsUserFilter, setNotificationsUserFilter] =
    useState(false);

  useEffect(() => {
    loadConfig();
  }, []);

  const loadConfig = async () => {
    const config = await getCommonConfig();

    setConfigData(config);
    setSavedConfig(config);

    setNotificationUrl1(config?.NotificationFluxx1 || "");
    setNotificationUrl2(config?.NotificationFluxx2 || "");
    setNotificationsUserFilter(!!config?.NotificationsUserFilter);
  };

  const hasChanges =
    savedConfig &&
    (
      notificationUrl1 !== (savedConfig.NotificationFluxx1 || "") ||
      notificationUrl2 !== (savedConfig.NotificationFluxx2 || "") ||
      notificationsUserFilter !==
        !!savedConfig.NotificationsUserFilter
    );

  const handleSave = async () => {
    setSaving(true);

    try {
      const payload = {
        ...configData,
        NotificationFluxx1: notificationUrl1,
        NotificationFluxx2: notificationUrl2,
        NotificationsUserFilter: notificationsUserFilter,
      };

      await updateCommonConfig(payload);

      setConfigData(payload);
      setSavedConfig(payload);
    } finally {
      setSaving(false);
    }
  };

  const handleCancel = () => {
    if (!savedConfig) return;

    setConfigData(savedConfig);

    setNotificationUrl1(savedConfig.NotificationFluxx1 || "");
    setNotificationUrl2(savedConfig.NotificationFluxx2 || "");
    setNotificationsUserFilter(
      !!savedConfig.NotificationsUserFilter
    );
  };

  return (
    <div className="border border-gray-200 rounded-md bg-[#fbfaf7] p-3 space-y-3">
      <div className="flex items-center gap-4 text-xs">
        <span className="w-44 text-gray-700">
          Notifications User Filter
        </span>

        <Toggle
          enabled={notificationsUserFilter}
          onToggle={setNotificationsUserFilter}
        />
      </div>

      <div className="flex items-center gap-4 text-xs">
        <span className="w-40 text-gray-700">
          Fluxx URL(for each record)
        </span>

        <input
          type="text"
          value={notificationUrl1}
          onChange={(e) => setNotificationUrl1(e.target.value)}
          className="flex-1 border border-gray-300 rounded px-3 py-1 text-xs focus:outline-none focus:ring-1 focus:ring-[var(--color-brand)]"
          placeholder="Enter Fluxx URL"
        />
      </div>

      <div className="flex items-center gap-4 text-xs">
        <span className="w-40 text-gray-700">
          Fluxx URL (view in Fluxx)
        </span>

        <input
          type="text"
          value={notificationUrl2}
          onChange={(e) => setNotificationUrl2(e.target.value)}
          className="flex-1 border border-gray-300 rounded px-3 py-1 text-xs focus:outline-none focus:ring-1 focus:ring-[var(--color-brand)]"
          placeholder="Enter Fluxx URL"
        />
      </div>

      <div className="flex justify-end gap-2 items-center pt-2">
        {hasChanges && (
          <div className="text-orange-600 border border-orange-300 bg-orange-50 px-2 py-0.5 rounded text-xs">
            Unsaved
          </div>
        )}

        <button
          className="bg-[#e7e5e0] px-3 py-1 text-xs"
          onClick={handleCancel}
          disabled={!hasChanges}
        >
          Cancel
        </button>

        <button
          className="bg-[var(--color-brand)] text-white px-3 py-1 text-xs"
          onClick={handleSave}
          disabled={!hasChanges || saving}
        >
          {saving ? "Saving..." : "Save"}
        </button>
      </div>
    </div>
  );
};

export default NotificationWidgetConfig;
